import { Injectable } from "@angular/core";
import { AbStepArea } from "app/abstract/full-pages/area-comum/step-area.abstract";
import { Observable } from "rxjs";

@Injectable({ providedIn: 'root' })
export class StepAreaService extends AbStepArea {

    public qtdFinalizadas: number = 1;

    public getResultadoCompleted(): number {
        return this.qtdFinalizadas;
    }

    observableCompleted(): Observable<boolean> {
        return new Observable((observer) => {
            setTimeout(() => {
                observer.next(true);
                observer.complete();
            }, 100);
        })
    }


    public setResultadoCompleted(): Observable<any> {
        this.qtdFinalizadas = this.qtdFinalizadas + 1;
        return this.observableCompleted();
    }

    public setVoltarResultadoCompleted(): Observable<any> {
        this.qtdFinalizadas = this.qtdFinalizadas - 1;
        return this.observableCompleted();
    }

    public reiniciarContagem() {
        this.qtdFinalizadas = 0;
    }

    public terminarContagem() {
        this.qtdFinalizadas = 8;
    }
} 